export const FEE_CATALOG = {
  GMF: 'GMF',
  GMF_INVERSE: 'GMF_INVERSE',
};

export const AMOUNT_MONEY = {
  ZERO_NUMBER: 0,
  ZERO: '0',
};

export const CURRENCY_CODES = {
  USD: 'USD',
  MXN: 'MXN',
  COP: 'COP',
};

export const CONTACT_METHODS = {
  EMAIL: 'email',
  SALES_EMAIL: 'sales_email',
  WHATSAPP: 'whatsapp',
  WEBSITE: 'website',
};

export const CONTACT_METHODS_LABEL = {
  [CONTACT_METHODS.EMAIL]: 'Email',
  [CONTACT_METHODS.SALES_EMAIL]: 'Sales Email',
  [CONTACT_METHODS.WHATSAPP]: 'WhatsApp',
  [CONTACT_METHODS.WEBSITE]: 'Website',
};

export const CONTACT_METHODS_LINK = {
  [CONTACT_METHODS.EMAIL]: 'mailto:help@efexpay.com',
  [CONTACT_METHODS.SALES_EMAIL]: 'mailto:sales@efexpay.com',
  [CONTACT_METHODS.WHATSAPP]:
    'https://api.whatsapp.com/send?phone=5215524950807',
  [CONTACT_METHODS.WEBSITE]: 'https://www.efexpay.com',
};

export const CONTACT_METHODS_VALUES = {
  [CONTACT_METHODS.EMAIL]: 'help@efexpay.com',
  [CONTACT_METHODS.SALES_EMAIL]: 'sales@efexpay.com',
  [CONTACT_METHODS.WHATSAPP]: '155-2495-0807',
  [CONTACT_METHODS.WEBSITE]: 'https://www.efexpay.com',
};

export const RATE_ROUNDING_MULTIPLIER = 10000;
export const RATE_ROUNDING_DECIMALS = 4;
export const MINIMAL_ADJUSTMENT = 0.0001;

export const RATE_VALIDATION_COMPARISON_KEYS = {
  LOWER: 'lower',
  GREATER: 'greater',
};
